import BusinessWelcomePage from './component'
export { BusinessWelcomePage }
export default BusinessWelcomePage